import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {

  constructor(private auth: AuthService, private router: Router) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot):
    boolean | UrlTree {
    const token = this.auth.getToken();

    if (!token) {
      this.auth.login(state.url);
      return false;
    }

    if (this.auth.hasAccessToWorkBench()) {
      console.log("user is studio/analysis...User", state.url);
      return true;
    }

    console.log("User is not authorized to given URL --> ", state.url);
    this.router.navigateByUrl("unauthorized");
    return false;
  }
}
